// removed by extract-text-webpack-plugin
module.exports = {"container":"inline-tabs__container___26DBh","tab":"inline-tabs__tab___3HOyk","tab--selected":"inline-tabs__tab--selected___36bhg","custom-tab-container":"inline-tabs__custom-tab-container___1ELg6","name":"inline-tabs__name___3yGoM","delete":"inline-tabs__delete___14_kI"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/common/inline-tabs.scss
// module id = 1307
// module chunks = 0